export const CONSTELLATIONS = [
  { stars: [[190, 260], [135, 200], [130, 145], [165, 118], [190, 150], [215, 118], [250, 145], [245, 200]], closed: true },
  { stars: [[420, 200], [430, 120], [465, 160], [500, 100], [535, 160], [570, 120], [580, 200]], closed: true },
  { stars: [[820, 110], [843, 170], [905, 172], [856, 210], [873, 270], [820, 235], [767, 270], [784, 210], [735, 172], [797, 170]], closed: true },
  { stars: [[230, 460], [262, 425], [300, 445], [360, 475], [398, 495], [430, 460], [398, 425], [360, 445], [300, 475], [262, 495]], closed: true },
  { stars: [[700, 380], [750, 400], [770, 450], [750, 500], [700, 520], [650, 500], [630, 450], [650, 400]], closed: true },
];

export const BG_STARS = Array.from({ length: 70 }, (_, i) => [(i * 137.5) % 1000, (i * 89.3 + 23) % 620, (i % 3) * 0.4 + 0.6]);
